import { CalendarOutlined } from '@ant-design/icons';
import { Flex, Progress, ProgressProps, Tooltip } from 'antd';
import './style.scss';

type CheckpointProgressBarProps = ProgressProps & {
  checkpointIcon?: React.ReactNode;
  checkpoint?: number;
  checkpointLabel?: string;
  checkpointColor?: string;
  startLabel?: React.ReactNode;
  endLabel?: React.ReactNode;
};

const CheckpointProgressBar = (props: CheckpointProgressBarProps) => {
  const {
    checkpointIcon = <CalendarOutlined />,
    checkpoint,
    checkpointLabel,
    checkpointColor = '#4096FF',
    startLabel,
    endLabel,
    ...restProps
  } = props;
  const validCheckpoint = checkpoint
    ? Math.max(0, Math.min(100, checkpoint))
    : 0;

  return (
    <Flex vertical>
      <div className="checkpoint-progress">
        {checkpoint === 0 || checkpoint ? (
          <Tooltip
            title={checkpointLabel || `Checkpoint at ${validCheckpoint}%`}
          >
            <span
              className="checkpoint-progress__checkpoint"
              style={{
                left: `${validCheckpoint}%`,
                background: checkpointColor,
              }}
            >
              {checkpointIcon}
            </span>
          </Tooltip>
        ) : null}
        <Progress showInfo={false} {...restProps} />
      </div>
      {startLabel && endLabel ? (
        <Flex justify="space-between">
          <span className="text-secondary text-small">{startLabel}</span>
          <span className="text-secondary text-small">{endLabel}</span>
        </Flex>
      ) : null}
    </Flex>
  );
};

export default CheckpointProgressBar;
